import { configure } from 'mobx'
import { createContext, FC, PropsWithChildren, useContext } from 'react'
import RootStore from './root-store'

configure({ enforceActions: 'never' })

// const rootStore = new RootStore()

// console.log('rootStore', rootStore)
const StoreContext = createContext<any>(RootStore)

export const StoreProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  return (
    <StoreContext.Provider value={RootStore}>{children}</StoreContext.Provider>
  )
}

export const useRootStore = () => useContext(StoreContext)
